(function () {

  'use strict';



  if (window.__productPageLayoutInit) return;

  window.__productPageLayoutInit = true;



  var MAX_ATTEMPTS = 80;

  var RETRY_MS = 80;

  var SCHEDULE_DELAY = 120;

  var LEFT_MOUNT_SEL = '[data-product-sidebar-mount]';

  var RIGHT_MOUNT_SEL = '[data-product-right-column-mount]';

  var BUNDLE_LEFT = 'product-landing__sticky-bundle';

  var BUNDLE_RIGHT = 'product-landing__scroll-column';

  var COLUMNS_ROW = 'product-landing__columns-row';

  var FULL_BOTTOM = 'product-landing__full-bottom';

  var layoutTimer = null;

  var initialLoad = true;



  function isProductTemplate() {

    return (

      document.body.classList.contains('template-product') ||

      document.body.className.indexOf('template-product') !== -1 ||

      !!document.querySelector('[data-product-sidebar-mount]')

    );

  }



  function isDesktop() {

    return window.matchMedia('(min-width: 1024px)').matches;

  }



  function isDesignMode() {

    return (

      document.documentElement.classList.contains('shopify-design-mode') ||

      !!(window.Shopify && window.Shopify.designMode)

    );

  }



  function getColumn(el) {

    return (el && el.getAttribute('data-product-desktop-column')) || 'left';

  }



  function getLeftMount() {

    return document.querySelector(LEFT_MOUNT_SEL);

  }



  function getRightMount() {

    return document.querySelector(RIGHT_MOUNT_SEL);

  }



  function isMainProductSection(sectionEl) {

    return !!(sectionEl && sectionEl.querySelector && sectionEl.querySelector(LEFT_MOUNT_SEL));

  }



  function getSectionColumn(sectionEl) {

    if (!sectionEl) return 'full';

    if (!isDesignMode() && sectionEl.classList.contains('section-product-page--relocated-empty')) return 'full';

    var marker = sectionEl.querySelector('[data-product-layout-column]');

    if (marker) return getColumn(marker);

    var panel = sectionEl.querySelector('[data-product-sidebar-panel], [data-product-page-panel]');

    if (panel) return getColumn(panel);

    return 'full';

  }



  function getMainContentSections() {

    var main = document.getElementById('MainContent');

    if (!main) return [];

    return Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));

  }



  function getAllShopifySections() {

    var main = document.getElementById('MainContent');

    if (!main) return [];

    return Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));

  }



  function applySectionColumnClasses() {

    var sections = getAllShopifySections();

    var firstLeftIndex = -1;

    var i;



    for (i = 0; i < sections.length; i++) {

      if (getSectionColumn(sections[i]) === 'left') {

        firstLeftIndex = i;

        break;

      }

    }



    sections.forEach(function (sectionEl, index) {

      var col = getSectionColumn(sectionEl);



      sectionEl.classList.remove(

        'product-landing-col--left',

        'product-landing-col--right',

        'product-landing-col--full',

        'product-landing-col--full-top',

        'product-landing-col--apps'

      );



      sectionEl.classList.add('product-landing-col--' + col);



      if (col === 'full' && firstLeftIndex > -1 && index < firstLeftIndex) {

        sectionEl.classList.add('product-landing-col--full-top');

      }



      if (sectionEl.querySelector('[data-product-section-type="apps"]')) {

        sectionEl.classList.add('product-landing-col--apps');

      }

    });



    document.documentElement.classList.add('product-page-layout-ready');

  }



  function unwrapDesktopLayout() {

    var main = document.getElementById('MainContent');

    if (!main) return;



    var fullBottom = main.querySelector(':scope > .' + FULL_BOTTOM);

    if (fullBottom) {

      while (fullBottom.firstChild) {

        main.insertBefore(fullBottom.firstChild, fullBottom);

      }

      fullBottom.remove();

    }



    var columnsRow = main.querySelector(':scope > .' + COLUMNS_ROW);

    if (columnsRow) {

      while (columnsRow.firstChild) {

        main.insertBefore(columnsRow.firstChild, columnsRow);

      }

      columnsRow.remove();

    }

  }



  function wrapColumnBundles() {

    if (!isDesktop()) return;



    var main = document.getElementById('MainContent');

    if (!main) return;



    var left = main.querySelector(':scope > .' + BUNDLE_LEFT);

    var right = main.querySelector(':scope > .' + BUNDLE_RIGHT);

    if (!left && !right) return;



    var row = main.querySelector(':scope > .' + COLUMNS_ROW);

    if (!row) {

      row = document.createElement('div');

      row.className = COLUMNS_ROW;

      main.insertBefore(row, left || right);

    }



    if (left && left.parentElement !== row) row.appendChild(left);

    if (right && right.parentElement !== row) row.appendChild(right);

  }



  function mountFullBottomSections() {

    if (!isDesktop()) return;



    var main = document.getElementById('MainContent');

    if (!main) return;



    var bottomSections = Array.prototype.slice.call(

      main.querySelectorAll(':scope > .shopify-section.product-landing-col--full:not(.product-landing-col--full-top)')

    );



    if (!bottomSections.length) return;



    var container = main.querySelector(':scope > .' + FULL_BOTTOM);

    if (!container) {

      container = document.createElement('div');

      container.className = FULL_BOTTOM;

      main.appendChild(container);

    }



    bottomSections.forEach(function (sectionEl) {

      container.appendChild(sectionEl);

    });

  }



  function repositionFullWidthBottomSections() {

    wrapColumnBundles();

    mountFullBottomSections();

  }



  function markLayoutStable() {

    if (!isProductTemplate() || isDesignMode()) return;



    document.documentElement.classList.remove('product-page-layout-loading');



    if (!isDesktop()) {

      document.documentElement.classList.add('product-page-layout-stable');

      return;

    }



    requestAnimationFrame(function () {

      requestAnimationFrame(function () {

        document.documentElement.classList.add('product-page-layout-stable');

      });

    });

  }



  function clearLayoutStable() {

    if (!isProductTemplate() || isDesignMode()) return;



    document.documentElement.classList.remove('product-page-layout-stable', 'product-page-layout-ready');



    if (isDesktop()) {

      document.documentElement.classList.add('product-page-layout-loading');

    }

  }



  function markSectionShell(sectionEl, empty) {

    if (!sectionEl || isDesignMode()) return;

    sectionEl.classList.toggle('section-product-page--relocated-empty', empty);

    sectionEl.classList.toggle('section-product-page--relocated', empty);

  }



  function rememberPanelHome(panel) {

    if (!panel || panel.getAttribute('data-product-home-section')) return;

    var sec = panel.closest('.shopify-section');

    if (sec && sec.id) {

      panel.setAttribute('data-product-home-section', sec.id);

    }

  }



  function getPanelHomeSection(panel) {

    if (!panel) return null;

    var secId = panel.getAttribute('data-product-home-section');

    if (secId) return document.getElementById(secId);

    return panel.closest('.shopify-section');

  }



  function movePanelToMount(panel, mount) {

    if (!panel || !mount || mount.contains(panel)) return;

    rememberPanelHome(panel);

    mount.appendChild(panel);

  }



  function returnPanelToSection(panel, sectionEl) {

    if (!panel || !sectionEl || sectionEl.contains(panel)) return;

    sectionEl.appendChild(panel);

  }



  function dedupePanels(selector, canonical) {

    if (isDesignMode()) return;

    document.querySelectorAll(selector).forEach(function (panel) {

      if (panel !== canonical) panel.remove();

    });

  }



  function markSourceSectionEmpty(role, canonical) {

    if (isDesignMode()) return;



    var hint = role === 'content' ? 'product_content' : 'product_purchase';

    var className = role === 'content' ? 'section-product-content' : 'section-product-purchase';



    document.querySelectorAll('.shopify-section').forEach(function (sec) {

      var id = sec.id || '';

      if (!sec.classList.contains(className) && id.indexOf(hint) === -1) return;

      markSectionShell(sec, !sec.contains(canonical));

    });

  }



  function restorePanelsFromHiddenRightMount() {

    var rightMount = getRightMount();

    if (!rightMount) return;



    Array.prototype.slice

      .call(rightMount.querySelectorAll('[data-product-page-panel]'))

      .forEach(function (panel) {

        var sectionEl = getPanelHomeSection(panel);

        if (sectionEl) {

          returnPanelToSection(panel, sectionEl);

          markSectionShell(sectionEl, false);

        }

      });

  }



  function relocateSidebarPanels(leftMount) {

    ['content', 'purchase'].forEach(function (role) {

      var selector = '[data-product-sidebar-panel="' + role + '"]';

      var panels = Array.prototype.slice.call(document.querySelectorAll(selector));

      if (!panels.length) return;



      var canonical = null;

      var i;

      for (i = 0; i < panels.length; i++) {

        if (!leftMount.contains(panels[i])) canonical = panels[i];

      }

      if (!canonical) canonical = panels[panels.length - 1];



      dedupePanels(selector, canonical);

      canonical.setAttribute('data-product-desktop-column', 'left');

      movePanelToMount(canonical, leftMount);

      markSourceSectionEmpty(role, canonical);

    });

  }



  function relocateMovablePanels() {

    restorePanelsFromHiddenRightMount();



    var leftMount = getLeftMount();

    var panels = document.querySelectorAll('[data-product-page-panel]');



    panels.forEach(function (panel) {

      var col = getColumn(panel);

      var sectionEl = getPanelHomeSection(panel) || panel.closest('.shopify-section');



      if (col === 'right') {

        if (sectionEl && !sectionEl.contains(panel)) {

          returnPanelToSection(panel, sectionEl);

        }

        if (sectionEl) markSectionShell(sectionEl, false);

        return;

      }



      if (col === 'left' && leftMount) {

        movePanelToMount(panel, leftMount);

        if (sectionEl) markSectionShell(sectionEl, !sectionEl.contains(panel));

      }

    });

  }



  function unbundleColumns() {

    unwrapDesktopLayout();



    var main = document.getElementById('MainContent');

    if (!main) return;



    [BUNDLE_LEFT, BUNDLE_RIGHT].forEach(function (className) {

      var bundle = main.querySelector(':scope > .' + className);

      if (!bundle) return;

      var parent = main;

      while (bundle.firstChild) {

        parent.insertBefore(bundle.firstChild, bundle);

      }

      bundle.remove();

    });

  }



  function bundleColumnSections(columnClass, bundleClass) {

    var main = document.getElementById('MainContent');

    if (!main) return;



    if (main.querySelector(':scope > .' + bundleClass)) return;



    var sections = Array.prototype.filter.call(main.querySelectorAll(':scope > .shopify-section'), function (sec) {

      return sec.classList.contains(columnClass);

    });



    if (!sections.length) return;



    var bundle = document.createElement('div');

    bundle.className = bundleClass;

    var first = sections[0];

    main.insertBefore(bundle, first);

    sections.forEach(function (sec) {

      bundle.appendChild(sec);

    });

  }



  function bundleProductColumns() {

    if (!isDesktop()) {

      unbundleColumns();

      return;

    }



    bundleColumnSections('product-landing-col--left', BUNDLE_LEFT);

    bundleColumnSections('product-landing-col--right', BUNDLE_RIGHT);

  }



  function enhanceProductGalleryDesktop() {

    if (!isProductTemplate() || !window.matchMedia('(min-width: 750px)').matches) return;



    var viewers = document.querySelectorAll(

      '.product-layout__left-column slider-component[id^="GalleryViewer-"], .product-landing__sticky-bundle slider-component[id^="GalleryViewer-"]'

    );



    viewers.forEach(function (viewer) {

      var list = viewer.querySelector('.product__media-list');

      var buttons = viewer.querySelector('.slider-buttons');

      if (!list) return;



      list.classList.add('slider--everywhere');



      if (buttons) {

        buttons.classList.remove('small-hide');

        buttons.setAttribute('data-product-gallery-nav', 'desktop');

      }

    });

  }



  function clearRelocatedState() {

    document.querySelectorAll('.shopify-section').forEach(function (sectionEl) {

      sectionEl.classList.remove('section-product-page--relocated', 'section-product-page--relocated-empty');

    });

  }



  function returnAllPanels() {

    unbundleColumns();

    restorePanelsFromHiddenRightMount();



    var leftMount = getLeftMount();



    if (leftMount) {

      leftMount.querySelectorAll('[data-product-sidebar-panel], [data-product-page-panel]').forEach(function (panel) {

        var sec = getPanelHomeSection(panel);

        if (sec) returnPanelToSection(panel, sec);

      });

    }



    clearRelocatedState();

  }



  function runEditorLayout() {

    if (!isProductTemplate()) return false;



    returnAllPanels();

    applySectionColumnClasses();

    bundleProductColumns();

    applySectionColumnClasses();

    repositionFullWidthBottomSections();

    enhanceProductGalleryDesktop();

    markLayoutStable();

    return true;

  }



  function runStorefrontLayout() {

    if (!isProductTemplate()) return false;



    var leftMount = getLeftMount();

    if (!leftMount) return false;



    applySectionColumnClasses();

    relocateSidebarPanels(leftMount);

    relocateMovablePanels();

    applySectionColumnClasses();

    bundleProductColumns();

    applySectionColumnClasses();

    repositionFullWidthBottomSections();

    enhanceProductGalleryDesktop();



    document.dispatchEvent(new CustomEvent('product-page:relocated'));

    document.dispatchEvent(new CustomEvent('product-sidebar:relocated'));

    markLayoutStable();

    return true;

  }



  function runLayout() {

    if (isDesignMode()) {

      return runEditorLayout();

    }

    return runStorefrontLayout();

  }



  function init(attempt) {

    attempt = attempt || 0;



    if (isProductTemplate()) {

      applySectionColumnClasses();

    }



    if (!isDesktop()) {

      returnAllPanels();

      applySectionColumnClasses();

      markLayoutStable();

      initialLoad = false;

      return;

    }



    if (runLayout()) {

      initialLoad = false;

      return;

    }



    if (attempt < MAX_ATTEMPTS) {

      window.setTimeout(function () {

        init(attempt + 1);

      }, RETRY_MS);

    } else {

      applySectionColumnClasses();

      bundleProductColumns();

      markLayoutStable();

      initialLoad = false;

    }

  }



  function scheduleInit(delay) {

    window.clearTimeout(layoutTimer);

    layoutTimer = window.setTimeout(function () {

      init(0);

    }, typeof delay === 'number' ? delay : SCHEDULE_DELAY);

  }



  function bootstrap() {

    if (initialLoad) {

      init(0);

      return;

    }

    scheduleInit(0);

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', bootstrap);

  } else {

    bootstrap();

  }



  window.addEventListener('resize', function () {

    if (isProductTemplate() && isDesktop() && document.documentElement.classList.contains('product-page-layout-stable')) {

      clearLayoutStable();

    }

    scheduleInit(SCHEDULE_DELAY);

  });



  document.addEventListener('shopify:section:unload', function (event) {

    if (event.target && isMainProductSection(event.target)) {

      returnAllPanels();

    }

    scheduleInit(80);

  });



  document.addEventListener('shopify:section:load', function () {

    scheduleInit(150);

  });



  window.ProductPageLayout = {

    relocate: runLayout,

    returnPanels: returnAllPanels,

    applySectionColumnClasses: applySectionColumnClasses,

    markLayoutStable: markLayoutStable,

    clearLayoutStable: clearLayoutStable

  };

  window.ProductSidebarLayout = window.ProductPageLayout;

})();


